import { Card } from 'react-bootstrap';
import './Help.css'

const Info = ({info}) => {
	return (
		<Card className="info-popup">
			<Card.Body>
				{info}
			</Card.Body>
		</Card>
	)
}

const Help = ({info, className}) => {
	return (
		<div className={"ms-2 m-auto " + className}>
			<div className="help-info">
				<i className="bi bi-question-circle text-secondary"></i>
				<Info info={info} />
			</div>
		</div>
	)
}

export default Help
